import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin);

document.addEventListener('DOMContentLoaded', function () {
  window.runScroll = function (el, o = 0, once = false) {
    const target = document.querySelector(el);
    if (!target) return;

    const topbar = document.querySelector('.js-topbar');
    const nav = document.querySelector('.js-nav');

    let offset = parseInt(o);
    let topbar_height = 0;

    if (document.body.classList.contains('page-it')) {
        if (window.innerWidth <= 1024 && topbar) {
            topbar_height = topbar.clientHeight;
        }
    } else if (topbar) {
        topbar_height = topbar.clientHeight;
    }

    if (nav && nav.classList.contains('is-visible')) {
        if (typeof window.hideMenu === 'function') {
            window.hideMenu();
        }
    }

    const scrollOptions = {
        duration: 0.8,
        scrollTo: {
            y: target,
            offsetY: topbar_height + offset
        },
        ease: "power2.out"
    };

    gsap.to(window, scrollOptions);

    if (!once) {
        setTimeout(() => {
            gsap.to(window, {
                ...scrollOptions,
                duration: 0.6,
                ease: "power1.out"
            });
        }, 500); 
    }
};



  const gtt = document.querySelectorAll('[data-target]');

  if (gtt.length > 0) {
    const action = function (e) {
      e.preventDefault();

      const target = e.currentTarget.dataset.target;
      const offset = e.currentTarget.dataset.offset;

      const targetEl = document.querySelector(target);
      //const baseUrl = location.protocol + '//' + document.domain + '/' + location.pathname.split('/')[1] + '/';
      const baseUrl = location.protocol + '//' + document.domain;

      if (targetEl) {
        window.runScroll(target, offset);
      } else {
        window.open(baseUrl + target, '_self');
      }
    };

    for (let i = 0; i < gtt.length; i++) {
      gtt[i].addEventListener('click', action);
    }
  }
});
